module.exports = __webpack_public_path__ + "static/media/default-avatar.f653841f.png";